export default __webpack_public_path__ + "static/media/Nitroxgallery_93.4f06ef41.webp";